import { render, staticRenderFns } from "./Order.vue?vue&type=template&id=022031b6&scoped=true&"
import script from "./Order.vue?vue&type=script&lang=js&"
export * from "./Order.vue?vue&type=script&lang=js&"
import style0 from "./Order.vue?vue&type=style&index=0&id=022031b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022031b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ctorres/Documents/Dev/MCD/lsm-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VAvatar,VChip,VRadio,VRadioGroup,VSelect})
